module.exports = __webpack_public_path__ + "img/Doctor.a37fca56.svg";